import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import { API, toast } from '@/App';
import SavedAddressesSection from '@/components/account/SavedAddressesSection';
import { Button } from '@/components/ui/button';
import { UI_NAV_LABELS, UI_PAGE_TITLES } from '@/constants/uiLabels';
import { resolveAccountBackLabel, resolveAccountBackPath } from '@/utils/accountNavigation';

const SavedAddressesPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadUser = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API}/auth/me`);
        if (active) {
          setUser(response.data || null);
        }
      } catch (error) {
        if (active) {
          toast.error(error.response?.data?.detail || 'Impossible de charger votre compte.');
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadUser();
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500 mx-auto" />
          <p className="mt-4 text-gray-600">Chargement de vos adresses...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="mx-auto max-w-6xl px-4 py-8 md:px-6">
        <div className="mb-6 flex items-center justify-between gap-4">
          <div>
            <p className="text-sm font-medium text-red-600">{UI_NAV_LABELS.savedAddresses}</p>
            <h1 className="text-3xl font-bold text-gray-900">{UI_PAGE_TITLES.savedAddresses}</h1>
            <p className="mt-2 text-sm text-gray-600">
              Enregistrez vos points de ramassage et vos autres adresses utiles pour eviter les ressaisies.
            </p>
          </div>
          <Button variant="outline" onClick={() => navigate(resolveAccountBackPath(user?.role))}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {resolveAccountBackLabel(user?.role)}
          </Button>
        </div>

        <SavedAddressesSection />
      </main>
    </div>
  );
};

export default SavedAddressesPage;
